import React from "react";
import Breadcrumb from "../../Components/Breadcrumb/Breadcrumb";
import AllAcountsSection from "../../Components/AllAccountsSection/AllAcountsSection";


import {
  AiOutlinePercentage,
  AiFillCreditCard,
  AiFillCaretRight,
  AiOutlineMail,
  AiOutlineMobile,
  AiOutlineArrowRight,
} from "react-icons/ai";
import { Link } from "react-router-dom";
import { useEffect } from "react";

const BusinessBanking = () => {
  const img9 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/business-banking-9.png";
const img10 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/business-banking-10.png";
const img11 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/business-banking-11.png";
const img12 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/business-banking-12.png";
const img13 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/business-banking-13.png";
const img14 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/business-banking-14.png";
const img15 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/business-banking-15.png";
const img16 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/business-banking-16.png";
const img17 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/business-banking-17.png";
const img18 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/business-banking-18.png";
const img19 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/business-banking-19.png";
const assetsFinance = "https://izbassetsmain.blob.core.windows.net/izbwebassets/asset-finance-img.png";
const foreignCurrency = "https://izbassetsmain.blob.core.windows.net/izbwebassets/foreign-currency-img.png";
const overdraft = "https://izbassetsmain.blob.core.windows.net/izbwebassets/overdraft-img.png";
const termLoan = "https://izbassetsmain.blob.core.windows.net/izbwebassets/term-loan-img.png";
const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/BackgroundBrundcrumb.png";
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Breadcrumb Heading="Business Banking" img={BackgroundBrundcrumb} show={true} btnTxt="Apply Now" />
      <div className="container">
        <div className="text-center text my-4">
          <h2>Current Accounts</h2>
        </div>
        <div className="row mt-4 g-5">
          <div className="col-12 col-md-6 col-lg-6 col-xl-6 m-md-0 mt-sm-1 my-3 ">
            <div className="row justify-content-sm-center">
              <div className="col-12 col-md-4 col-xl-4 p-0">
                <img
                  src={img9}
                  style={{ height: "20rem", objectFit: "cover" }}
                  className="img-fluid w-100"
                  alt=""
                />
              </div>
              <div
                className=" col-12 col-md-8 col-xl-8 pe-0 text-white p-3"
                style={{ backgroundColor: "#9E1B1E",height: "20rem" }}
              >
                <h4 className="text-white pe-2">IZB Privilege Current A/C</h4>
                <p className="text text-white fs-4 my-2">Purpose</p>
              
                  <p className="fs-small pt-1 lh-sm pe-4">
                    This is a business current account offering premier business
                    banking solutions and services designed specifically to meet
                    business operation needs including concessions on service
                    charges
                  </p>

                <span className="d-flex justify-content-between align-items-center mt-2 h-50 me-4">
                  <Link to="/PrivilegeCurrentAcc">
                    <button className="btn btn-light py-0">Apply now</button>
                  </Link>
                  <Link to="/PrivilegeCurrentAcc" className="text-white">
                    Know more <AiOutlineArrowRight />{" "}
                  </Link>
                </span>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6 col-lg-6 col-xl-6 m-md-0 mt-sm-1  my-3 ">
            <div className="row justify-content-sm-center">
              <div className="col-12 col-md-4 col-xl-4 p-0">
                <img
                  src={img10}
                  style={{ height: "20rem", objectFit: "cover" }}
                  className="img-fluid w-100"
                  alt=""
                />
              </div>
              <div
                className=" col-12 col-md-8 col-xl-8 pe-0 text-white p-3"
                style={{ backgroundColor: "#9E1B1E",height: "20rem" }}
              >
                <h4 className="text-white pe-2">Classic Current Account</h4>
                <p className="text text-white fs-4 my-2">Benefits</p>
                <p className="fs-small pt-1 lh-sm pe-4">
                  <img
                    src={foreignCurrency}
                    className="me-2"
                    width="15"
                    alt=""
                  />
                  Foreign exchange services
                </p>
                <p className="fs-small pt-1 lh-sm pe-4">
                  <img src={overdraft} className="me-2" width="15" alt="" />
                  Overdraft.
                </p>
                <p className="fs-small pt-1 lh-sm pe-4">
                  <img src={assetsFinance} className="me-2" width="15" alt="" />
                  Asset Financing.
                </p>
                <p className="fs-small pt-1 lh-sm pe-4">
                  <img src={termLoan} className="me-2" width="15" alt="" />
                  Term Loans.
                </p>
                <div className="d-flex justify-content-between me-4 h-50 align-items-center">
                  <Link to="/ClassicCurrentAccount">
                    <button className="btn btn-light py-0">Apply now</button>
                  </Link>
                  <Link to="/ClassicCurrentAccount" className="text-white">
                    Know more <AiOutlineArrowRight />{" "}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row g-5 mt-4">
          <div className="col-12 col-md-6 col-lg-6 col-xl-6 m-md-0 mt-sm-1  my-3 ">
            <div className="row justify-content-sm-center">
              <div className="col-12 col-md-4 col-xl-4 p-0">
                <img
                  src={img11}
                  style={{ height: "20rem", objectFit: "cover" }}
                  className="img-fluid w-100"
                  alt=""
                />
              </div>
              <div
                className=" col-12 col-md-8 col-xl-8 pe-0 text-white p-3"
                style={{ backgroundColor: "#9E1B1E",height: "20rem" }}
              >
                <h4 className="text-white pe-2">SME Current Account</h4>
                <p className="text text-white fs-4 my-2">Benefits</p>
                <p className="fs-small pt-1 lh-sm pe-4">
                  <img
                    src={foreignCurrency}
                    className="me-2"
                    width="15"
                    alt=""
                  />
                  Foreign exchange services
                </p>
                <p className="fs-small pt-1 lh-sm pe-4">
                  <img src={overdraft} className="me-2" width="15" alt="" />
                  Overdraft.
                </p>
                <p className="fs-small pt-1 lh-sm pe-4">
                  <img src={assetsFinance} className="me-2" width="15" alt="" />
                  Asset financing
                </p>
                <p className="fs-small pt-1 lh-sm pe-4">
                  <img src={termLoan} className="me-2" width="15" alt="" />
                  Term Loans.
                </p>
                <div className="d-flex justify-content-between me-4 h-50 align-items-center">
                  <Link to="/SMECurrentAcc">
                    <button className="btn btn-light py-0">Apply now</button>
                  </Link>
                  <Link to="/SMECurrentAcc" className="text-white">
                    Know more <AiOutlineArrowRight />{" "}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container my-5 pb-5">
        <div className="text-center text">
          <h2>Credit</h2>
        </div>
        <div className="row mt-4 gx-5">
          <div className="col-12 col-md-6 col-lg-6 col-xl-6 m-md-0 mt-sm-1 my-3">
            <div className="row justify-content-sm-center">
              <div className="col-12 col-md-4 col-xl-4 p-0">
                <img
                  src={img12}
                  style={{ height: "20rem", objectFit: "cover" }}
                  className="img-fluid w-100"
                  alt=""
                />
              </div>
              <div
                className=" col-12 col-md-8 col-xl-8 pe-0 text-white p-3"
                style={{ backgroundColor: "#9E1B1E",height: "20rem" }}
              >
                <h4 className="text-white pe-2">MSME Loan</h4>
                <p className="text text-white fs-4 my-2">Purpose</p>
                <span>
                  <AiFillCaretRight className="position-absolute mt-2" />
                  <p className="fs-small pt-1 lh-sm px-3">
                  The MSME Sector is the corner stone of any great economy. We
                  firmly on board to act as a catalyst for the economic
                  development of Zambia
                  </p>
                </span>
                <div className="d-flex justify-content-between me-4 mt-2 h-50 align-items-center">
                  <Link to="/MSMELoan">
                    <button className="btn btn-light py-0">Apply now</button>
                  </Link>
                  <Link to="/MSMELoan" className="text-white">
                    Know more <AiOutlineArrowRight />{" "}
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6 col-lg-6 col-xl-6 m-md-0 mt-sm-1 my-3">
            <div className="row justify-content-sm-center">
              <div className="col-12 col-md-4 col-xl-4 p-0">
                <img
                  src={img13}
                  style={{ height: "20rem", objectFit: "cover" }}
                  className="img-fluid w-100"
                  alt=""
                />
              </div>
              <div
                className=" col-12 col-md-8 col-xl-8 pe-0 text-white p-3"
                style={{ backgroundColor: "#9E1B1E",height: "20rem" }}
              >
                <h4 className="text-white pe-2">Term Loan</h4>
                <p className="text text-white fs-4 my-2">Purpose</p>
                <span>
                  <AiFillCaretRight className="position-absolute mt-2" />
                  <p className="fs-small pt-1 lh-sm px-3">
                  Access our long and short-term loans designed to meet your
                  specific funding requirements.
                  </p>
                </span>
                <div className="d-flex justify-content-between me-4 mt-4 pt-1 h-50 align-items-center">
                  <Link to="/TermLoan">
                    <button className="btn btn-light py-0">Apply now</button>
                  </Link>
                  <Link to="/TermLoan" className="text-white">
                    Know more <AiOutlineArrowRight />{" "}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-4 g-5">
          <div className="col-12 col-md-6 col-lg-6 col-xl-6 m-md-0 mt-sm-1 my-3">
            <div className="row justify-content-sm-center">
              <div className="col-12 col-md-4 col-xl-4 p-0">
                <img
                  src={img14}
                  style={{ height: "20rem", objectFit: "cover" }}
                  className="img-fluid w-100"
                  alt=""
                />
              </div>
              <div
                className=" col-12 col-md-8 col-xl-8 pe-0 text-white p-3"
                style={{ backgroundColor: "#9E1B1E",height: "20rem" }}
              >
                <h4 className="text-white pe-2">IZB Auto Finance</h4>
                <p className="text text-white fs-4 my-2">Purpose</p>
                <span>
                  <AiFillCaretRight className="position-absolute mt-2" />
                  <p className="fs-small pt-1 lh-sm px-3">
                  Purchase of brand new and second hand utility vehicle. Age of
                  Second- hand vehicle not to exceed 5 years.
                  </p>
                </span>
              
                <div className="d-flex justify-content-between me-4 mt-4 pt-2 h-50 align-items-center">
                  <Link to="/AutoFinance">
                    <button className="btn btn-light py-0">Apply now</button>
                  </Link>
                  <Link to="/AutoFinance" className="text-white">
                    Know more <AiOutlineArrowRight />{" "}
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6 col-lg-6 col-xl-6 m-md-0 mt-sm-1 my-3">
            <div className="row justify-content-sm-center">
              <div className="col-12 col-md-4 col-xl-4 p-0">
                <img
                  src={img15}
                  style={{ height: "20rem", objectFit: "cover" }}
                  className="img-fluid w-100"
                  alt=""
                />
              </div>
              <div
                className=" col-12 col-md-8 col-xl-8 pe-0 text-white p-3"
                style={{ backgroundColor: "#9E1B1E",height: "20rem" }}
              >
                <h4 className="text-white pe-2">IZB Agro Finance</h4>
                <p className="text text-white fs-4 my-2">Purpose</p>
                <span>
                  <AiFillCaretRight className="position-absolute mt-2" />
                  <p className="fs-small pt-1 lh-sm px-3">
                  We understand the need for food security and the importance
                  agriculture plays into the country’s national development
                  goals. At Indo Zambia Bank we study, examine and analyse the
                  ﬁnancial aspects pertaining to farm business.
                  </p>
                </span>
                
                <div className="d-flex justify-content-between me-4 h-50 pb-3 align-items-center">
                  <Link to="/AgroFinance">
                    <button className="btn btn-light py-0">Apply now</button>
                  </Link>
                  <Link to="/AgroFinance" className="text-white">
                    Know more <AiOutlineArrowRight />{" "}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row mt-4 g-5">
          <div className="col-12 col-md-6 col-lg-6 col-xl-6 m-md-0 mt-sm-1 my-3">
            <div className="row justify-content-sm-center">
              <div className="col-12 col-md-4 col-xl-4 p-0">
                <img
                  src={img16}
                  style={{ height: "20rem", objectFit: "cover" }}
                  className="img-fluid w-100"
                  alt=""
                />
              </div>
              <div
                className=" col-12 col-md-8 col-xl-8 pe-0 text-white p-3"
                style={{ backgroundColor: "#9E1B1E",height: "20rem" }}
              >
                <h4 className="text-white pe-2">Equity Release</h4>
                <p className="text text-white fs-4 my-2">Purpose</p>
                <span>
                  <AiFillCaretRight className="position-absolute mt-2" />
                  <p className="fs-small pt-1 lh-sm px-3">
                  Looking for a quick finance solution and have immovable
                  assets. Our equity release is a solution to get financing
                  backed by your assets.
                  </p>
                </span>
             
                <div className="d-flex justify-content-between me-4 mt-4 h-50 align-items-center">
                  <Link to="/EquityRelease">
                    <button className="btn btn-light py-0">Apply now</button>
                  </Link>
                  <Link to="/EquityRelease" className="text-white">
                    Know more <AiOutlineArrowRight />{" "}
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6 col-lg-6 col-xl-6 m-md-0 mt-sm-1 my-3">
            <div className="row justify-content-sm-center">
              <div className="col-12 col-md-4 col-xl-4 p-0">
                <img
                  src={img17}
                  style={{ height: "20rem", objectFit: "cover" }}
                  className="img-fluid w-100"
                  alt=""
                />
              </div>
              <div
                className=" col-12 col-md-8 col-xl-8 pe-0 text-white p-3"
                style={{ backgroundColor: "#9E1B1E",height: "20rem" }}
              >
                <h4 className="text-white pe-2">Business Finance</h4>
                <p className="text text-white fs-4 my-2">Purpose</p>
                <span>
                  <AiFillCaretRight className="position-absolute mt-2" />
                  <p className="fs-small pt-1 lh-sm px-3">
                  This is a specialised overdraft facility for business designed
                  for business for quick working capital solutions backed by
                  security.
                  </p>
                </span>
                <div className="d-flex justify-content-between me-4 h-50 mt-4 align-items-center">
                  <Link to="/BusinessFinance">
                    <button className="btn btn-light py-0">Apply now</button>
                  </Link>
                  <Link to="/BusinessFinance" className="text-white">
                    Know more <AiOutlineArrowRight />{" "}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-4 g-5">
          <div className="col-12 col-md-6 col-lg-6 col-xl-6 m-md-0 mt-sm-1 my-3">
            <div className="row justify-content-sm-center">
              <div className="col-12 col-md-4 col-xl-4 p-0">
                <img
                  src={img18}
                  style={{ height: "20rem", objectFit: "cover" }}
                  className="img-fluid w-100"
                  alt=""
                />
              </div>
              <div
                className=" col-12 col-md-8 col-xl-8 pe-0 text-white p-3"
                style={{ backgroundColor: "#9E1B1E",height: "20rem" }}
              >
                <h4 className="text-white pe-2">Working Capital Finance</h4>
                <p className="text text-white fs-4 my-2">Purpose</p>
                <span>
                  <AiFillCaretRight className="position-absolute mt-2" />
                  <p className="fs-small pt-1 lh-sm px-3">
                  Improve working capital by unlocking funds caught in the
                  supply chain, and manage incoming and outgoing cash flows more
                  effectively with IZB overdraft facility.
                  </p>
                </span>
                <div className="d-flex justify-content-between me-4 h-50 mt-2 align-items-center">
                  <Link to="/WorkingCapitalFinance">
                    <button className="btn btn-light py-0">Apply now</button>
                  </Link>
                  <Link to="/WorkingCapitalFinance" className="text-white">
                    Know more <AiOutlineArrowRight />{" "}
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6 col-lg-6 col-xl-6 m-md-0 mt-sm-1 my-3">
            <div className="row justify-content-sm-center">
              <div className="col-12 col-md-4 col-xl-4 p-0">
                <img
                  src={img19}
                  style={{ height: "20rem", objectFit: "cover" }}
                  className="img-fluid w-100"
                  alt=""
                />
              </div>
              <div
                className=" col-12 col-md-8 col-xl-8 pe-0 text-white p-3"
                style={{ backgroundColor: "#9E1B1E",height: "20rem" }}
              >
                <h4 className="text-white pe-2">Lease Rental Discounting </h4>
                <p className="text text-white fs-4 my-2">Purpose</p>
                <span>
                  <AiFillCaretRight className="position-absolute mt-2" />
                  <p className="fs-small pt-1 lh-sm px-3">
                  Need ﬁnancing against future receivables. We have your back.
                  </p>
                </span>
                <div className="d-flex justify-content-between me-4 h-75 mt-3 align-items-center">
                  <Link to="/LeaseRentalDiscounting">
                    <button className="btn btn-light py-0">Apply now</button>
                  </Link>
                  <Link to="/LeaseRentalDiscounting" className="text-white">
                    Know more <AiOutlineArrowRight />{" "}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AllAcountsSection />
    </>
  );
};

export default BusinessBanking;
